"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const simplifiedPrizesInputs = [
  {
    name: "logoUrl",
    friendlyName: "RedeemPrizes Dialog Logo",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
  },
  {
    name: "logoAlt",
    friendlyName: "Alt Text for Logo",
    type: "string",
    defaultValue: "Logo Alt",
  },
  {
    name: "discoverUrlParent",
    friendlyName: "Discover button parent URL",
    type: "string",
    required: false,
  },
  {
    name: "prizeCardSizeVariant",
    friendlyName: "Prize Card Size Variant",
    type: "string",
    enum: ["default", "small"],
    defaultValue: "default",
  },
  {
    name: "pointsLabel",
    friendlyName: "Points Label",
    type: "string",
    defaultValue: "Points",
    required: true,
  },
  {
    name: "discoverButtonText",
    friendlyName: "Discover button text",
    type: "string",
    required: false,
  },
  {
    name: "earnPointsCtaText",
    friendlyName: "Earn points button text",
    type: "string",
    defaultValue: "Earn {#missingPoints#} to redeem.",
    required: true,
  },
  {
    name: "earnPointsCtaUrl",
    friendlyName: "Earn points button url",
    type: "string",
    required: true,
  },
  {
    name: "ctaLabel",
    friendlyName: "CTA Label",
    type: "string",
    defaultValue: "Redeem Now",
    required: true,
  },
  {
    name: "color",
    friendlyName: "Font color",
    type: "string",
    enum: [
      { label: "Light", value: "white" },
      { label: "Dark", value: "black" },
    ],
    defaultValue: "white",
  },
  {
    name: "noOffersText",
    friendlyName: "No Offers Text",
    type: "string",
    defaultValue: "No offers available.",
    required: true,
  },
  {
    name: "newOfferDays",
    friendlyName: "New Offer Days",
    helperText: "How many days old prize is considered new",
    type: "number",
    defaultValue: 7,
  },
  {
    name: "newLabel",
    friendlyName: "New Label",
    type: "string",
    defaultValue: "New!",
    required: true,
  },
  {
    name: "oneDayLabel",
    friendlyName: "Last day label",
    type: "string",
    defaultValue: "Last day!",
  },
  {
    name: "daysLabel",
    friendlyName: "Days Label",
    type: "string",
    defaultValue: "{#days#} days left",
    helperText: "Uses placeholders for dynamic data such as: {#days#}",
  },
  {
    name: "pagination",
    friendlyName: "Pagination",
    type: "number",
    defaultValue: 3,
    required: true,
  },
  {
    name: "isTeaser",
    friendlyName: "Is Teaser",
    type: "boolean",
    defaultValue: true,
    required: true,
  },
  {
    name: "teaserData",
    friendlyName: "Teaser Data",
    type: "object",
    showIf: 'options.get("isTeaser") === true',
    subFields: [
      {
        name: "teaserTitle",
        friendlyName: "Teaser Title",
        type: "string",
        required: true,
      },
      {
        name: "teaserLinkUrl",
        friendlyName: "Teaser Link URL",
        type: "url",
        required: true,
      },
      {
        name: "teaserLinkText",
        friendlyName: "Teaser Link Text",
        type: "string",
        required: true,
      },
    ],
    defaultValue: {
      teaserTitle: "LATEST ADDITION TO REWARD’S CATALOGUE",
      teaserLinkUrl: "#",
      teaserLinkText: "View all rewards",
    },
    required: true,
  },
  {
    name: "loadMoreButtonLabel",
    friendlyName: "Load More Button Label",
    type: "string",
    defaultValue: "Load More",
    required: true,
  },
  {
    name: "errorMessage",
    friendlyName: "Error Message",
    type: "string",
    defaultValue: "Something went wrong, please try again later",
  },
  {
    name: "outOfStockLabel",
    friendlyName: "Out of Stock Label",
    type: "string",
    defaultValue: "Out of Stock",
    required: true,
  },
] as const satisfies Inputs;

export const SimplifiedPrizesV2Component: RegisteredComponent = {
  name: "SimplifiedPrizesV2",
  component: dynamic(async () =>
    withValidation(
      simplifiedPrizesInputs,
      (await import("./SimplifiedPrizesV2")).SimplifiedPrizesV2,
      "SimplifiedPrizesV2"
    )
  ),
  inputs: simplifiedPrizesInputs,
};
